import axios from "../axios";
import { getCurrentUser } from "../auth/service";

function isPersistedAuthenticatedStoreUser() {
  try {
    const user = getCurrentUser();
    if (!user || typeof user !== "object" || user.temp === true) return false;
    const mobile = String(user.mobile ?? "")
      .trim()
      .toLowerCase();
    return mobile.length > 0 && !mobile.startsWith("guest_");
  } catch (_err) {
    return false;
  }
}

/** Fire-and-forget lead funnel activity for anonymous / lead visitors. */
export function trackStoreLeadEvent(eventType, meta = {}) {
  if (isPersistedAuthenticatedStoreUser()) return;
  const type = String(eventType ?? "").trim();
  if (!type) return;

  axios
    .post("/store/lead_events", { event_type: type, meta })
    .catch(() => {});
}

export function trackStoreLeadSignupStart() {
  trackStoreLeadEvent("signup_start");
}
